const Roles = {
  ADMIN: 'admin',
  WAITER: 'chelner',
  KITCHEN: 'bucatarie'
}

export default Roles
